import React from 'react';
import me from '../../../images/me.png';
import  './AboutDetail.css';
import { Link } from 'react-router-dom';


const AboutDetail = () => {
    return (
        <div>
            <div className="row mt-5 aboutBody" >
                <div className="col-md-6 col-sm-12 text-white mt-5 pe-1">
                    <img src={me} className="picture" alt="myphoto"/>
                    <h1 className="textLight">Rajon Ahmed</h1>
                    <p> A self-motivated and enthusiastic web developer with a deep interest in JavaScript. I enjoy creating modern web applications. Desire To work in the Software industry with modern web technologies of different local & multinational Software/ IT agencies of Bangladesh and grow rapidly with increasing responsibilities.</p>
                    <div className="mt-4">
                        <a href="https://drive.google.com/file/d/1CFRJrxyGnpdezcUhO1FzDhWZsmdPmomk/view" target='_blank' rel="noreferrer"><button type="button" className="me-4 btn btn-success"> My Resume</button></a>
                        <a href="https://www.linkedin.com/in/rajon749/" rel="noreferrer" target="_blank"><button type="button" className="btn btn-outline-success">Hire me</button></a>
                    </div>
                </div>
                <div className="col-md-6 mt-5 col-sm-12">
                    <div className="tehnology text-white">
                        <h4 className="mb-4">Programming Skills </h4>
                        <h5 className="mt-3">Expertise: </h5>
                        <span>Javascript</span>
                        <span>ES6</span>
                        <span>React.js</span>
                        <span>REST API</span>
                        <span>React Bootstrap</span> <br/>
                        <span>Material-UI</span>
                        <span>Bootstrap4</span>                    
                        <span>HTML5</span>
                        <span>CSS3</span>                     
                        <button className="btn">.</button>
                        <h5 className="mt-3">Comfortable:</h5>
                        <span>Node js</span>
                        <span>Express js</span>
                        <span>MongoDB</span>                    
                        <span>Redux js</span>
                        <span>JSON</span>
                        <span>SCASS</span> 
                        <button className="btn">.</button>
                        <h5 className="mt-3">Tools:</h5>
                        <span>Git</span>
                        <span>Github</span>
                        <span>Firebase</span>
                        <span>Heroku</span>
                        <span>Netlify</span>
                        <span>NPM</span>
                        <span>Webpack</span> <br/>
                        <span>VS Code</span>
                        <span>Chrome dev tool</span>
                        <button className="btn">.</button>
                    </div>
                </div>
            </div>
            <div className="row mt-5 mx-auto">
                <div className="mt-5 col-md-8 text-white mx-auto text-center">
                    <h4>Visit my recent projects</h4>
                    <Link to="/projects"> Click here</Link>
                </div>
            </div>
        </div>
    );
};

export default AboutDetail;